import { TeamAccessDTO } from '../team/team-access.dto';
import { ProductListDTO } from '../product/product-list.dto';

export class ErrorTypeDTO extends TeamAccessDTO {

    name: string;

    description: string;

    products: Array<ProductListDTO>;
    
}
